module.exports = __webpack_public_path__ + "static/fiveStarProspects-2dabdb25aed3ec014dcd1ea132b8de0a.png";